import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { centsToDollars } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class RefundPaymentIntentModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      showModal: false,
      defaultMethod: props.method,
      method: props.method === "manual" ? "cash" : props.method,
      checkNumber: "",
      achMemo: "",
      formError: "",
      type: "refund",
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.setMethod = this.setMethod.bind(this)
    this.submit = this.submit.bind(this)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false, formError: null })
  }

  setMethod(e) {
    this.setState({ method: e.target.value, formError: null })
  }

  checkSelected() {
    return this.state.method === "check"
  }

  offlineAchSelected() {
    return this.state.method === "ach"
  }

  cashSelected() {
    return this.state.method === "cash"
  }

  isCreditRefund() {
    return this.state.type === "refund" && this.state.defaultMethod === "credit"
  }

  isAutomatedAchRefund() {
    return (
      this.state.type === "refund" &&
      this.state.defaultMethod === "automated_ach"
    )
  }

  isManualRefund() {
    return this.state.type === "refund" && this.state.defaultMethod === "manual"
  }

  refundAmount() {
    return centsToDollars(-this.props.rawAmount)
  }

  shouldSendReceipt() {
    return !!this.props.contactEmail
  }

  submit() {
    this.setState({ saving: true, formError: null })
    const params = {
      payment_method: this.state.method,
      check_number: this.state.checkNumber,
      ach_memo: this.state.achMemo,
      receipt_behavior: this.shouldSendReceipt(),
      amount: this.props.rawAmount,
      payment_method_unique: this.props.paymentMethodUnique,
    }

    $.post(this.props.postUrl, params, (data) => {
      window.location.reload(false)
    }).fail((data) => {
      this.setState({
        saving: false,
        formError: JSON.parse(data.responseText).error,
      })
    })
  }

  renderTextWarning() {
    let text
    if (this.state.method === "credit") {
      text = `Are you sure? This will refund ${this.refundAmount()} to the card on file.`
    } else if (this.state.method === "automated_ach") {
      text = `Are you sure? This will refund ${this.refundAmount()} to the bank account on file.`
    } else if (this.state.method === "dockwa_dollar") {
      text = `Are you sure? This will return ${this.refundAmount()} Dockwa Dollars to the customer.`
    } else {
      text = `This will mark ${this.refundAmount()} as refunded on the reservation.`
    }

    return <div className="col-xs-12 my-3">{text}</div>
  }

  renderPaymentMethod() {
    const classWidth = this.cashSelected() ? "col-xs-12" : "col-xs-6"
    if (["credit", "dockwa_dollar"].includes(this.state.method)) {
      return null
    }
    return (
      <div className={classWidth}>
        <FormGroup
          inputType="select"
          label="Refund method"
          name="method"
          value={this.state.method}
          onChange={(e) => this.setMethod(e)}
        >
          {this.isCreditRefund() && (
            <option key="credit" value="credit">
              Card
            </option>
          )}
          {this.isAutomatedAchRefund() && (
            <option key="automated_ach" value="automated_ach">
              ACH
            </option>
          )}
          {this.isManualRefund() && (
            <option key="cash" value="cash">
              Cash
            </option>
          )}
          {this.isManualRefund() && (
            <option key="check" value="check">
              Check
            </option>
          )}
          {this.isManualRefund() && (
            <option key="ach" value="ach">
              Offline ACH
            </option>
          )}
        </FormGroup>
      </div>
    )
  }

  renderCheckNumberForm() {
    return (
      this.checkSelected() && (
        <div className="col-xs-6">
          <FormGroup
            inputType="input"
            label="Check number"
            name="checkNumber"
            value={this.state.checkNumber}
            onChange={this.handleInputChange}
          />
        </div>
      )
    )
  }

  renderAchMemoForm() {
    return (
      this.offlineAchSelected() && (
        <div className="col-xs-6">
          <FormGroup
            inputType="input"
            label="ACH memo"
            name="achMemo"
            value={this.state.achMemo}
            onChange={this.handleInputChange}
          />
        </div>
      )
    )
  }

  renderReceiptConfirm() {
    return (
      this.props.contactEmail && (
        <div className="col-xs-12">
          <FormGroup
            label="Email receipt to boater"
            inputType="checkbox"
            className="my-0"
            name="sendReceipt"
            value={this.shouldSendReceipt()}
            onChange={this.handleInputChange}
            disabled={this.shouldSendReceipt()}
          />
        </div>
      )
    )
  }

  renderModalSave() {
    if (
      ["credit", "dockwa_dollars", "automated_ach"].includes(this.state.method)
    ) {
      return "Okay"
    } else {
      return "Add refund"
    }
  }

  renderFormErrors() {
    if (this.state.formError) {
      return (
        <div className="col-xs-12 text-danger mb-3">{this.state.formError}</div>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        <LegacyButton
          type="secondary"
          className="btn-sm"
          onClick={this.openModal}
        >
          {this.props.buttonText}
        </LegacyButton>

        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="small"
        >
          <Modal.Header title="Settle refund" />
          <Modal.Body>
            <div className="row-flex form-row">
              {this.renderTextWarning()}
              {this.renderPaymentMethod()}
              {this.renderCheckNumberForm()}
              {this.renderAchMemoForm()}
              {this.renderReceiptConfirm()}
              {this.renderFormErrors()}
            </div>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText={this.renderModalSave()}
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.submit}
          />
        </Modal>
      </div>
    )
  }
}

RefundPaymentIntentModal.propTypes = {
  buttonText: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  rawAmount: PropTypes.number.isRequired,
  paymentMethodUnique: PropTypes.string,
  contactEmail: PropTypes.string,
}

export default RefundPaymentIntentModal
